import React from 'react';
import $ from 'jquery';
import { MAX_SHARE_URL_LENGTH, isMobile } from '../../constants/Constants';
import { truncateString } from '../../helpers/tools';

class ShareLinkPopUp extends React.Component {
  constructor(props) {
    super(props);
  }

  shouldComponentUpdate(nextProps) {
    if (!nextProps.configurationUrl.loading) {
      this.showPopUp();
      return true;
    }
    return false;
  }

  showPopUp = () => {
    if (this.timeoutID) {
      this.props.restorePopUpConfiguration(this.timeoutID, '#copy-link-btn');
    }

    const popUp = $('#share-link-pop-up');
    const popUpClass = 'shareLinkPopUp';

    popUp.addClass(popUpClass);

    $(document).on(isMobile ? 'touchend' : 'mousedown', this.closePopUp);
  };

  closePopUp = (event, triggerer) => {
    const popUp = $('#share-link-pop-up');
    const popUpClass = 'shareLinkPopUp';

    const shouldClose = triggerer === 'shareLinkPopUp' || !triggerer;
    if (shouldClose && !popUp.find(event.target).length && popUp[0] !== event.target) {
      $(document).off(isMobile ? 'touchend' : 'mousedown', this.closePopUp);
      popUp.removeClass(popUpClass);
    }
  };

  onCopy = () => {
    navigator.clipboard.writeText(this.props.configurationUrl.value);
    $('#copy-link-btn').text('Copied');
    this.timeoutID = setTimeout(this.clearCopytButtonTimeout, 1000);
  };

  clearCopytButtonTimeout = () => {
    $(document).trigger(isMobile ? 'touchend' : 'mousedown', ['shareLinkPopUp']);
    $('#copy-link-btn').text('Copy');
    clearTimeout(this.timeoutID);
  };

  render() {
    return (
      <div id="share-link">
        <div id="share-link-content">
          {truncateString(this.props.configurationUrl.value, MAX_SHARE_URL_LENGTH)}
        </div>
        <div id="copy-link-btn" className="popUpBtn" onClick={() => this.onCopy()}>
          Copy
        </div>
      </div>
    );
  }
}

export default ShareLinkPopUp;
